import React, { useMemo } from "react";
import * as Scrivito from "scrivito";
import { Container } from "reactstrap";
import NiceModal from "@ebay/nice-modal-react";
import cx from "classnames";
import { Button, FilterTag } from "components";
import { useProjectStatuses, useTranslate } from "hooks";
import { ProjectDetailsModal } from "components/_Modals/ProjectDetailsModal/ProjectDetailsModal";
import { ModifyProjectMut } from "api/mutations";
import { useCountryList } from "hooks/useCountryList";
import s from "../ProjectItemSame.module.scss";
import { useIsSameProj, useLanguage } from "stores/globalStore";
import { useProjectActions, useProject } from "stores/project";

export const ProjectItemProperies = Scrivito.connect(({ fetching }) => {
  const project = useProject();
  const translate = useTranslate();
  const { refetch } = useProjectActions();
  /* TODO: forthcoming feature (hidden acc US-19953) */
  const isSameProj = useIsSameProj();
  const lang = useLanguage();

  const toggleModalEditProperties = () => {
    setTimeout(() => {
      NiceModal.show(ProjectDetailsModal, {
        project,
        mutation: ModifyProjectMut,
      }).then(() => {
        refetch();
      });
    }, 300);
  };

  const projectStatuses = useProjectStatuses(isSameProj);

  const status = useMemo(() => {
    const color = projectStatuses?.find(
      (item) => item.status === project?.status?.status,
    )?.color;
    return {
      status: project?.status?.status,
      color,
    };
  }, [project?.status, projectStatuses]);

  const countryList = useCountryList({ language: lang });
  const country = useMemo(
    () =>
      countryList?.find(
        ({ isoTwoLetterCode }) => isoTwoLetterCode === project?.country,
      ),
    [countryList, project],
  );

  return (
    <>
      <div className="bg-gray-100">
        <Container className="d-flex flex-column px-4 py-4 bg-white mb-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="text-uppercase">
              {translate("PROJECT_PROPERTIES")}
            </h3>
            <Button
              color="secondary"
              outline
              disabled={!project || fetching}
              onClick={toggleModalEditProperties}
            >
              {translate("EDIT_PROPERTIES")}
            </Button>
          </div>

          <div className="d-flex w-100">
            <div className="col-8 mr-5 mb-3 ps-4 pe-5_5">
              <div className="d-flex px-2_5 py-3 border-bottom border-1 border-gray-300">
                <div className="col-6 font-bold">
                  {translate("PROJECT_NAME")}
                </div>
                <div className={cx("col-6", s.textWrap)}>
                  {project?.title || "-"}
                </div>
              </div>
              <div className="d-flex px-2_5 py-3 border-bottom border-1 border-gray-300">
                <div className="col-6 font-bold">
                  {translate("PROJECT_CONSTRUCTION_TITLE_INPUT_LABEL")}
                </div>
                <div className="col-6">{project?.constructionTitle || "-"}</div>
              </div>
              {isSameProj && (
                <div className="d-flex px-2_5 py-3 border-bottom border-1 border-gray-300">
                  <div className="col-6 font-bold">
                    {translate("PROJECT_LOCATION")}
                  </div>
                  <div className="col-6">{country?.displayName || "-"}</div>
                </div>
              )}
              <div className="d-flex px-2_5 py-3 border-bottom border-1 border-gray-300">
                <div className="col-6 font-bold">
                  {translate("PROJECT_NUMBER")}
                </div>
                <div className="col-6">{project?.projectNumber || "-"}</div>
              </div>
              <div className="d-flex px-2_5 py-3 border-bottom border-1 border-gray-300">
                <div className="col-6 font-bold">
                  {translate("PROJECT_UNITS")}
                </div>
                <div className="col-6">
                  {project?.unit &&
                    translate(
                      `PROJECT_UNITS_${project.unit.unit.toUpperCase()}`,
                    )}
                </div>
              </div>
              <div className="d-flex px-2_5 py-3 border-bottom border-1 border-gray-300">
                <div className="col-6 font-bold">
                  {translate("PROJECT_SHARING_SETTINGS")}
                </div>
                <div className="col-6 d-flex justify-content-between align-items-center">
                  <div>
                    <FilterTag
                      name={
                        project?.sharedWith?.length > 0
                          ? translate("SHARED")
                          : translate("NOT_SHARED")
                      }
                      icon={
                        project?.sharedWith?.length > 0
                          ? "user-group-regular"
                          : "user-regular"
                      }
                    />
                  </div>
                  {/* TODO: forthcoming feature (hidden acc US-19953) */}
                  {/* <Button
                    color="transparent"
                    className="d-flex align-items-center justify-content-center p-0 text-blue-300 shadow-none"
                    onClick={() => setShowDetailsOpen(!isShowDetailsOpen)}
                  >
                    {translate("SHOW_DETAILS")}
                  </Button> */}
                </div>
              </div>
              <div className="d-flex px-2_5 py-3 border-bottom border-1 border-gray-300">
                <div className="col-6 font-bold">
                  {translate("PROJECT_LIST_STATUS")}
                </div>
                <div className="col-6">
                  {status.status ? (
                    <FilterTag name={status.status} color={status.color} />
                  ) : (
                    "-"
                  )}
                </div>
              </div>
            </div>
            <div className="col-4 px-4">
              <span className="d-inline-block mb-3 font16 font-bold">
                {translate("ADDITIONAL_NOTES")}
              </span>
              <p className="">{project?.description || "-"}</p>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
});
